import * as Yup from 'yup';

import React, { useEffect, useMemo, useState } from 'react';
import { Container, Button, Box, Stack, Grid, Typography, MenuItem } from '@mui/material';
import styled from '@emotion/styled';
import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup';
import { debounce } from 'lodash';
import RHFAutocompleteBasic from '../hooks/rhf-autocomplete-filter';
import { getAllDistrict, getAllState } from '../server/api/region';
import { RHFSelect } from '../hooks/rhf-select';
import { RHFTextField } from '../hooks';
import RHFPhoneField from '../hooks/rhf-phone-input-new';
import { createBooking } from '../server/api/inspectionBooking';
import { getVehicleDetails } from '../server/api/vehicle';
import { useDevice } from '../hooks/useResponsive';
import { MetaHelmet } from '../layouts/Helmet/Helmet';
import SubmitModal from './popup';

export default function BookingPage() {
  const { isMobile } = useDevice();
  const dispatch = useDispatch();
  const params = useParams();
  const [countryCode, setCountryCode] = useState('91');

  const navigate = useNavigate();
  const [modal, setModal] = React.useState(false);

  const [finalDistrictSearchText, setFinalDistrictSearchText] = useState('');
  const [district, setDistrict] = useState('');
  const [state, setState] = useState('');

  const [finalStateSearchText, setFinalStateSearchText] = useState('');

  const { vehicleDetails, allStates, allDistricts } = useSelector((state) => ({
    vehicleDetails: state.vehicle.vehicleDetails,
    loading: state.vehicle.loading,
    allStates: state?.region?.states,
    allDistricts: state?.region?.districts,
  }));

  const CustomButton = styled(Button)({
    background: '#F8971C',
    color: '#342C2C',
    borderRadius: '10px',
    height: '50px',
    boxShadow: '0 10px 10px rgba(0, 0, 0, 0.9)',
    fontSize: '21px',
    // fontWeight: '900',
    marginTop: '15px',
    '&:hover': {
      background: '#F8971C',
      color: '#342C2C',
    },
  });

  const CustomButtonWeb = styled(Button)({
    width: '25%',
    background: '#F8971C',
    color: '#342C2C',
    borderRadius: '10px',
    height: '40px',
    boxShadow: '0 10px 10px rgba(0, 0, 0, 0.9)',
    fontSize: '20px',
    // fontWeight: '900',
    marginTop: '15px',
    '&:hover': {
      background: '#F8971C',
      color: '#342C2C',
    },
  });
  const { watch, reset } = useForm({
    defaultValues: {
      name: '',
      phone: '',
      pincode: '',
      message: '',
    },
  });
  const phone = watch('phone');
  const expectedLength = countryCode === '968' ? 8 : 10;
  const showLengthError = phone && phone.length !== expectedLength;
  const defaultValues = useMemo(() => ({}), []);

  const FormSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    message: Yup.string(),
    phone: Yup.string()
      .length(countryCode === '968' ? 8 : 10, `Phone number must be exactly ${countryCode === '968' ? 8 : 10} digits`)
      .required('Phone number is required'),
    whatsapp: Yup.string()
      .min(10, 'Phone must be at least 10 characters')
      .max(15, 'Phone must not exceed 15 characters'),
    pincode: Yup.string(),
    address: Yup.string(),
    city: Yup.string(),

    payment_type: Yup.string(),
  });

  const methods = useForm({
    resolver: yupResolver(FormSchema),
    defaultValues,
  });
  const onSubmit = async (value, e) => {
    e?.preventDefault();
    console.log(value);
    const credentials = {
      state: {
        user_details: {
          name: value?.name,
          phone: value?.phone,
          address: value?.address,
          whatsapp: value?.whatsapp,
          pincode: value?.pincode,
          country_code: countryCode,
          district: district?.value || null,
          state: state?.value || null,
          city: value?.city,
        },
        vehicle_details: {
          brand: vehicleDetails?.brand?._id,
        },
        payment_type: value?.payment_type,
        // payment_type: payment,
      },
      dispatch,
      reset,
      navigate,
    };
    // console.log('credentials >>>>>', credentials);
    dispatch(createBooking(credentials));
  };
  const paymentOptions = [
    { label: 'Online', value: 'ONLINE' },
    { label: 'Pay Later', value: 'PAY_LATER' },
  ];
  useEffect(() => {
    const credentials = {
      vehicleId: params?.id,
      dispatch,
    };
    dispatch(getVehicleDetails(credentials));
  }, [dispatch, params?.id]);
  useEffect(() => {
    const filterSortObj = {
      // filter_data: { is_deleted: false },
      sort_data: '',
    };
    const credentials = {
      page: 1,
      search: finalDistrictSearchText,
      dispatch,
      limit: 10,
      state: filterSortObj,
    };
    dispatch(getAllDistrict(credentials));
  }, [dispatch, finalDistrictSearchText]);
  useEffect(() => {
    const filterSortObj = {
      // filter_data: { is_deleted: false },
      sort_data: '',
    };
    const credentials = {
      page: 1,
      search: finalStateSearchText,
      dispatch,
      limit: 10,
      state: filterSortObj,
    };
    dispatch(getAllState(credentials));
  }, [dispatch, finalStateSearchText]);

  const optionState = [
    ...(allStates?.States || []).map((results) => ({
      // label: results?.name?.english,
      label: `${results?.name || ''}`,
      value: results?._id,
    })),
  ];
  const optionDistrict = [
    ...(allDistricts?.districts || []).map((results) => ({
      // label: results?.name?.english,
      label: `${results?.name || ''}`,
      value: results?._id,
    })),
  ];
  const handleChangeDistrict = (e, value) => {
    setDistrict(value);
  };
  const handleChangeStates = (e, value) => {
    setState(value);
  };
  const debouncedStatesDebouncedText = debounce((value) => setFinalStateSearchText(value), 600);

  const handleStateSearch = (e) => {
    debouncedStatesDebouncedText(e.target.value);
  };
  const debouncedDistrictDebouncedText = debounce((value) => setFinalDistrictSearchText(value), 600);

  const handleDistrictSearch = (e) => {
    debouncedDistrictDebouncedText(e.target.value);
  };

  return (
    <>
      <FormProvider {...methods}>
        <MetaHelmet title={'Dream Car Booking'} companyName={'Focus Motors'} />
        <SubmitModal open={modal} close={() => setModal(false)} />
        <Box className="bg-color">
          <Container maxWidth="lg" sx={{ padding: '0px 10px 100px 10px' }}>
            <form onSubmit={methods.handleSubmit(onSubmit)}>
              <Box px={{ xs: 1, sm: 2, md: 3 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <RHFTextField required name="name" label="Name" type="text" fullWidth />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <RHFTextField name="whatsapp" label="Whatsapp Number" type="number" fullWidth />
                  </Grid>

                  <Grid item xs={12}>
                    <Stack spacing={1}>
                      <RHFPhoneField
                        name="phone"
                        label="Phone"
                        required
                        countryCode={countryCode}
                        setCountryCode={setCountryCode}
                        InputLabelProps={{
                          style: {
                            backgroundColor: '#121212',
                            padding: '0 4px',
                          },
                        }}
                      />
                      <Typography variant="caption" color={showLengthError ? 'error' : 'text.secondary'}>
                        {showLengthError && <span>Phone number must be exactly {expectedLength} digits</span>}
                      </Typography>
                    </Stack>
                  </Grid>

                  <Grid item xs={12}>
                    <RHFTextField name="address" label="Address" multiline rows={4} fullWidth />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <RHFTextField
                      name="pincode"
                      label="PIN Code"
                      type="number"
                      size="small"
                      placeholder="PIN Code"
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <RHFSelect name="payment_type" required label="Payment Type" size="small" fullWidth>
                      {/* <MenuItem value="" disabled>
                        Select payment option
                      </MenuItem> */}
                      {paymentOptions?.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option?.label}
                        </MenuItem>
                      ))}
                    </RHFSelect>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <RHFAutocompleteBasic
                      label="State"
                      options={optionState}
                      handleChangeValue={handleChangeStates}
                      handleChangeSearch={handleStateSearch}
                      placeholder="Select a State..."
                      size="small"
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <RHFAutocompleteBasic
                      label="District"
                      options={optionDistrict}
                      handleChangeValue={handleChangeDistrict}
                      handleChangeSearch={handleDistrictSearch}
                      placeholder="Select a District..."
                      size="small"
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <RHFTextField name="city" label="City" type="text" fullWidth />
                  </Grid>

                  <Grid item xs={12}>
                    {isMobile ? (
                      <CustomButton type="submit" variant="contained" className="request-btn" fullWidth>
                        Book My Dream Car
                      </CustomButton>
                    ) : (
                      <Box display="flex" justifyContent="flex-end">
                        <CustomButtonWeb type="submit" variant="contained">
                          Book My Dream Car
                        </CustomButtonWeb>
                      </Box>
                    )}
                  </Grid>
                </Grid>
              </Box>

              {/* <Box mt={3} px={0}>
                <RHFTextField name="name" label="Name" type="text" />
                <RHFTextField name="whatsapp" label="Whatsapp Number" type="number" />
                <Stack mb={1}>
                  <Box>
                    <RHFPhoneField
                      name="phone"
                      label="Phone"
                      countryCode={countryCode}
                      setCountryCode={setCountryCode}
                    />
                  </Box>
                  <Typography variant="caption" mt={1} color={showLengthError ? 'error' : 'text.secondary'}>
                    {showLengthError && (
                      <span style={{ marginLeft: 8 }}>Phone number must be exactly {expectedLength} digits</span>
                    )}{' '}
                  </Typography>
                </Stack>
                <RHFTextField name="address" label="Address" multiline rows={4} />{' '}
                <RHFTextField name="pincode" label="PIN Code" type="number" size="small" placeholder="PIN Code" />
                <RHFSelect name="payment_type" label="Payment Type" size="small">
                  <MenuItem value="" disabled>
                    Select payment option
                  </MenuItem>
                  {paymentOptions?.map((option) => (
                    <MenuItem
                      key={option.value}
                      value={option.value}
                      // onClick={handleChangeOrderStatus}
                    >
                      {option?.label}
                    </MenuItem>
                  ))}
                </RHFSelect>
                <RHFAutocompleteBasic
                  label="State"
                  options={optionState}
                  handleChangeValue={handleChangeStates}
                  handleChangeSearch={handleStateSearch}
                  placeholder="Select a State..."
                  size="small"
                />
                <RHFAutocompleteBasic
                  label="District"
                  options={optionDistrict}
                  handleChangeValue={handleChangeDistrict}
                  handleChangeSearch={handleDistrictSearch}
                  placeholder="Select a District..."
                  size="small"
                />
                <RHFTextField name="city" label="City" type="text" />
                {isMobile ? (
                  <CustomButton type="submit" variant="contained" className="request-btn" fullWidth>
                    Book My Dream Car
                  </CustomButton>
                ) : (
                  <Box display={'flex'} alignItems={'center'} justifyContent={'flex-end'}>
                    <CustomButtonWeb type="submit" variant="contained" className="">
                      Book My Dream Car
                    </CustomButtonWeb>
                  </Box>
                )}
              </Box> */}
            </form>
          </Container>
        </Box>
      </FormProvider>
    </>
  );
}
